module.exports = __webpack_public_path__ + "img/safety_precautions.0acb25be.png";